import api from "../../api";
import { Suspense, useState, useEffect } from "react";
import { useParams } from "react-router";
import SimpleTable from "../../components/SimpleTable";
import Link from "../../components/Link";
import { AdminContainer } from "../../components/layouts";
import Time from "../../lithic/Moment";
import Money from "../../lithic/Money";

export default function PartnerInvoicesPage() {
  const { id } = useParams();
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    if (id) {
      api.getPartnerInvoices({ id }).then(api.pick("data.items")).then(setInvoices);
    }
  }, [id]);

  return (
    <AdminContainer variant="list">
      <Suspense fallback={<div>Loading...</div>}>
        <SimpleTable
          tableProps={{ size: "small" }}
          headers={["Invoices", "Status", "Amount", "Begin", "End"]}
          rows={invoices}
          keyRowAttr="id"
          toCells={(row) => [
            <Link key={1} to={`/invoices/${row.id}`}>
              {row.id}
            </Link>,
            <Link key={4} to={`/invoices/${row.id}`}>
              {row.status === "paid" ? "paid" : "unpaid"}
            </Link>,
            <Money key={2} value={row.total} />,
            <Time key={5} format={"MMM DD, YYYY HH:mm:ss"} timezone="Etc/GMT+5">
              {row.period.start}
            </Time>,
            <Time key={6} format={"MMM DD, YYYY HH:mm:ss"} timezone="Etc/GMT+5">
              {row.period.end}
            </Time>,
          ]}
        />
      </Suspense>
    </AdminContainer>
  );
}
